<template>
<div>
    <!-- 语言选择 -->
    <div class="lang-select" @click="showLangPicker = true">
        <van-field 
            label-width="0" 
            readonly 
            :value="langValue" 
            placeholder="Language" 
        />
    </div>
    <!-- {{ telgarmId }} -->
    <!-- 语言选择弹窗 -->
    <van-popup v-model="showLangPicker" position="bottom" :style="{ height: '40%' }">
        <van-picker
            :confirm-button-text="$t('qd')" 
            :cancel-button-text="$t('qx')"
            ref="langPickers"
            v-model="langIndex"
            show-toolbar
            :columns="langColumns"
            value-key="label"
            @cancel="showLangPicker = false"
            @confirm="onLangConfirm"
        />
    </van-popup>
    <div class="logincent" v-show="!shows">
        <div class="conten" >
            <van-form  class="fromctent">
                <div class="phone ">
                    <select @click="selectHand">
                        <option :value ="this.address">{{this.address}}</option>
                    </select>
                    <van-field
                    v-model="mobile"
                    :placeholder="$t('sjhm')"
                    :border="true"
                    left-icon="friends"
                    clearable
                    size='large'
                    />
                </div>
                
                <div class="phone ">
                    <van-field
                    style="height:46px"
                    left-icon="bag"
                    v-model="verify_code"
                    center
                    clearable
                    :placeholder="$t('mm')"
                    >
                    <!-- <template #button>
                        <van-button size="small" @click="handldCode" class="codem" :disabled="disabled" color="#48C9B0">{{Codename}}</van-button>
                    </template> -->
                </van-field>
                </div>
                
				
				<div class="phone " style="margin-top: 10px;" @click="showPopup" v-show ="columns.length>1">
					<van-field label-width="0" readonly v-model="value"  :placeholder="$t('xzsq')" />
				</div>
				
                <div style="margin-top: 26px;">
                    <van-button  block color="#48C9B0" class="loginbut" native-type="submit" @click="onSubmit">
                        <span style="font-size: 22px;">{{$t('login')}}</span>
                    </van-button
                >
                </div>
            </van-form>
            <div class="logintop">
                <div @click="toggleLoginMode" >{{shows ? $t('ysjhmdl') : $t('yIDhmmdl')}}</div>
                <div @click="Retrievepasadmin" >{{$t('注册管理员')}}</div>
                <div @click="Retrievepas" >{{$t('zhmm')}}</div>
            </div>
			
			<!-- 社区弹窗 -->
			<van-popup v-model="showPicker" position="bottom" :style="{ height: '40%' }" >
				<van-picker
					:confirm-button-text="$t('qd')" :cancel-button-text="$t('qx')"
					ref="pickers"
					v-model="agent_id"
					show-toolbar
					value-key="name"
					:columns="columns"
					@cancel="showPicker = false"
					@confirm="onConfirm"
				/>
			</van-popup>
            
        </div>
    
    </div>
    <div v-show="shows" class="logincent">
        <div class="IDpasw">
            <van-form  class="fromctent">
                <van-field
                v-model="reg_id"
                :placeholder="$t('qsrID')"
                :border="true"
                left-icon="friends"
                clearable
                size='large'
                />

                <van-field
                    v-model="password"
                    :placeholder="$t('qsrmm')"
                    :border="true"
                    left-icon="bag"
                    clearable
                    size='large'
                    type="password"
                />
                <div style="margin-top: 26px;">
                    <van-button  block color="#48C9B0" class="loginbut" native-type="submit" @click="onSubmitID">
                        <span style="font-size: 22px;">{{$t('login')}}</span>
                    </van-button
                >
                </div>
            </van-form>
            <div class="logintop">
                <div @click="toggleLoginMode" >{{shows ? $t('ysjhmdl') : $t('yIDhmmdl')}}</div>
                <div @click="Retrievepasadmin" >{{$t('注册管理员')}}</div>
                <div @click="Retrievepas" >{{$t('zhmm')}}</div>
            </div>
            
        </div>
        
    </div>
</div>
  
</template>

<script>
import { Toast } from 'vant';
import WebApp from '@twa-dev/sdk';
export default {
    data(){
        return{
            address:localStorage.getItem('address')?localStorage.getItem('address'):'+86',
            mobile:'',
            verify_code:'',
            Codename:this.$t('fsyzm'),
            disabled:false,
            shows:false,
            // ID密码
            reg_id:'',
            password:'',
			showPicker:false,
			columns: [],
			value:'',
			agent_id:'',
			// 语言切换
			currentLang: localStorage.getItem('locale') || 'cn',
			showLangPicker: false,
			langIndex: 0,
			langColumns: [
				{ value: 'cn', label: '中文' },
				// { value: 'tw', label: '繁體中文' },
				{ value: 'en', label: 'English' },
				// { value: 'de', label: 'Deutsch' },
				{ value: 'es', label: 'Español' },
				// { value: 'fr', label: 'Français' },
				// { value: 'hi', label: 'हिन्दी' },
				// { value: 'ko', label: '한국어' },
				// { value: 'pt', label: 'Português' },
				{ value: 'ru', label: 'Русский' },
				{ value: 'ar', label: 'العربية' }
			],
            telgarmId:''
        }
    },  
    computed: {
        langValue() {
            const lang = this.langColumns.find(item => item.value === this.currentLang);
            return lang ? lang.label : '中文';
        }
    },
    mounted() {
        this.$nextTick(() => {
            const user = WebApp.initDataUnsafe?.user;
            if (user) {
                this.telgarmId = user.id;
                // 存储到本地
                localStorage.setItem('telgarmId', this.telgarmId);
            } else {
                // 如果仍然拿不到，可能是真的没有用户数据
                console.warn('未获取到用户数据，请确认是否在 Telegram Mini App 内打开');
                this.telgarmId = ''
            }
        });
        // 设置初始语言索引
        const index = this.langColumns.findIndex(item => item.value === this.currentLang);
        if (index !== -1) {
            this.langIndex = index;
        }
    },
    methods:{
        onLangConfirm(value) {
            this.currentLang = value.value;
            this.$i18n.locale = value.value;
            localStorage.setItem('locale', value.value);
            this.showLangPicker = false;
        },
        selectHand(){
            this.$router.push({path:'/indexbar'})
            
        },
        // 验证码
        handldCode(){


            if(!this.mobile){
                Toast.fail(this.$t('qsrsjhm'));
                return false
            }
            
            let mobiles =this.address+'-'+ this.mobile
            let data = {
                method:'co.sms.code.get',
                mobile:mobiles
            }
            console.log(data)

            this.$serve3(data).then(res=>{
                if(res.data.code==0){
                    this.disabled = true
                    let second = 60
                    var clearTimeSet=setInterval( () =>{
                        this.Codename = second+this.$t('mhzxhq')
                        second=second-1
                    if(second==0){
                        clearInterval(clearTimeSet);
                        this.disabled = false
                        this.Codename = this.$t('fsyzm')
                    }
                    }, 1000);
                    // this.verify_code = res.data.data.verify_code
                }else{
                    Toast.fail(this.$t('hqyzmsb'));
                }

            })
        },
        // 登录
        onSubmit(){
			let mobiles
			if(this.address=='+86'){
			     mobiles = this.mobile
			}else{
			     mobiles = this.address+'-'+ this.mobile
			}
            // mobiles = this.address+'-'+ this.mobile
            console.log(mobiles)
			let params = {
				method:'co.wx.user.agent.list',
				mobile:mobiles,
				password:this.$md5(this.verify_code),
			}
			this.$serve3(params).then(res=>{
				console.log(res.data.data)
				if(res.data.code==0){
					this.columns=res.data.data
					if(this.columns.length == 1){
						this.login(res.data.data[0])
					}
				}else{
			        Toast.fail(this.$t('zhmmcw'));
			    }
			})
        },
        // 切换登录模式
        toggleLoginMode(){
            this.shows = !this.shows
        },

        goregin(){
            this.$router.push({ path: '/regin' })
        },
        Retrievepas(){
            this.$router.push({ path: '/retpassword' })
        },
        Retrievepasadmin(){
            this.$router.push({ path: `/register?telegram_id=${this.telgarmId}` })
        },
        // ================ID和密码登录========================

        onSubmitID(){
            let data = {
                method:'co.wx.id.login',
                reg_id:this.reg_id,
                password:this.$md5(this.password)
            }
            this.$serve(data).then(res=>{
                if(res.data.code==0){
                    let getTokendata = JSON.stringify(res.data.data)
                    localStorage.setItem('getTokendata',getTokendata)
                    this.$router.push({ path: '/' })
                }else{
                    Toast.fail(this.$t('zhhmmcw'));
                }
            })
        },
		showPopup() {
			this.showPicker = true;
		},
		onConfirm(value) {
            console.log(value)
			this.login(value)
			// this.value = value.name;
			this.showPicker = false;
		},
		login(value){
			let mobiles
			if(this.address=="+86"){
			    mobiles =this.mobile
			}else{
			    mobiles =this.address+'-'+ this.mobile
			}
            // mobiles =this.address+'-'+ this.mobile
			let data = {
			    method:'co.wx.pwd.login',//'co.wx.login',
			    password:this.$md5(this.verify_code),
			    mobile:mobiles,
			    verify_code:'0',
			    platform:'pwa',
				agent_id:value.id,
                person_type:value.person_type,
                // telegram_id:this.telgarmId
			}
			this.$serve(data).then(res=>{
			    console.log(res)
			    if(res.data.code==0){
			       let getTokendata = JSON.stringify(res.data.data)
			       localStorage.setItem('getTokendata',getTokendata)
			        this.$router.push({ path: '/' })
			    }else{
			        Toast.fail(this.$t('zhhyzmcw'));
			    }
			})
		}


    }
}
</script>

<style scoped lang="scss">
.lang-select {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 999;
  width: 120px;
}
.lang-select >>> .van-field__control {
  font-size: 14px;
  text-align: right;
}
.logincent {
  width: 100%;
  height: 100%;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}
.conten {
  width: 90%;
  height: 300px;
  margin-top: 47%;
  border-radius: 10px;
  box-shadow: #d5d5d5 0px 0px 10px;
}
.fromctent{
    width: 88%;
    margin: 0 auto;
    margin-top:53px;
}
.fromctent >>>.van-field__left-icon .van-icon-friends{
    font-size: 26px;
    margin-left: -5px;
    color: #CCCCCC;
}
.fromctent >>>.van-cell--large{
    border: 1px solid #DBDBDB;
    border-radius: 3px;
    padding: 10px;
    margin-bottom: 10px;
}
.fromctent >>>.van-cell--center{
    border: 1px solid #DBDBDB;
    border-radius: 5px;
    padding: 6px;
}
.fromctent >>>.van-field__left-icon .van-icon-bag{
    font-size: 28px;
    /* margin-left: 2px; */
    color: #CCCCCC;
}
.codem{
    border-radius:4px ;
}
.loginbut{
    border-radius:5px ;
}
/* ID密码登录 */

.IDpasw{
    width: 90%;
    height: 300px;
    margin-top: 47%;
    border-radius: 10px;
    box-shadow: #d5d5d5 0px 0px 10px;
}
.logintop{
    padding: 0 20px;
    margin-top:30px;color:#48C9B0;
    display: flex;
    justify-content: space-between;
}
.phone{
    display: flex;
    height: 46px;
    border: 1px solid #DBDBDB;
    margin-bottom: 10px;
    border-radius: 5px;
    padding:0px 2px;
}
.phone select{
    height: 42px;
    border: none;
    line-height: 35px;
    padding:2px;
    border-right: 1px solid #DBDBDB;
    background-color: #fff;
    color: #323233;
}
.fromctent .phone >>> .van-cell--large{
    border: none;
    border-radius: 0px;
}   
</style>